module.exports = __webpack_public_path__ + "img/3.f291c582.png";